import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import styles from './MaskedInput.module.css';

export default function MaskedInput({
  value,
  onChange,
  type = 'text',
  className = '',
  id,
  required,
  autoComplete,
  readOnly,
}) {
  const [isVisible, setIsVisible] = useState(false);

  const inputType = type === 'password' ? (isVisible ? 'text' : 'password') : type;

  const inputClass = className || styles.input;

  return (
    <div className={styles.group}>
      <input
        type={inputType}
        className={inputClass}
        id={id}
        value={value}
        onChange={onChange}
        required={required}
        autoComplete={autoComplete}
        readOnly={readOnly}
      />
      {type === 'password' && (
        <button
          className={styles.toggle}
          type="button"
          aria-label={isVisible ? 'Hide password' : 'Show password'}
          onClick={(e) => {
            e.preventDefault();
            setIsVisible((v) => !v);
          }}
        >
          {isVisible
            ? <EyeOff size={16} strokeWidth={1.75} aria-hidden="true" />
            : <Eye size={16} strokeWidth={1.75} aria-hidden="true" />}
        </button>
      )}
    </div>
  );
}
